"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-png.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-.9 6.3h4.95L13.1 4.35V9.3zm-6.6 7.813c0 .132.045.24.135.323.09.083.204.125.343.125a.49.49 0 00.345-.125.42.42 0 00.135-.323.426.426 0 00-.136-.329.487.487 0 00-.344-.126.483.483 0 00-.342.126.426.426 0 00-.136.329zm4.553-1.14v-.044c0-.508-.109-.906-.325-1.195-.217-.29-.521-.434-.912-.434a.995.995 0 00-.802.37l-.03-.311H8.2v4.388h.847v-1.494a.988.988 0 00.776.334c.377 0 .677-.147.898-.44.222-.295.333-.686.333-1.174zm-.847-.062c0 .662-.202.993-.606.993-.266 0-.45-.104-.554-.313v-1.298c.1-.203.282-.305.548-.305.199 0 .35.08.455.24.105.16.157.388.157.683zm2.15-1.552h-.796v3.17h.846v-2.236a.582.582 0 01.536-.305c.182 0 .312.041.39.122.078.081.117.211.117.391v2.028h.847V15.48c-.004-.393-.088-.688-.252-.885-.164-.197-.414-.296-.75-.296-.38 0-.685.142-.911.425l-.027-.366zm2.458 1.561v.035c0 .492.118.887.353 1.185.236.298.544.447.925.447a.98.98 0 00.77-.33v.169c0 .22-.062.391-.187.511s-.3.18-.525.18a.992.992 0 01-.767-.354l-.375.516c.113.146.28.266.5.358.221.093.448.14.68.14.307 0 .575-.054.803-.162.229-.107.406-.263.532-.468.126-.205.189-.447.189-.724v-3.064h-.768l-.035.298c-.193-.238-.464-.357-.811-.357-.393 0-.705.148-.936.445-.232.297-.348.689-.348 1.175zm.847.062c0-.33.058-.578.174-.744a.554.554 0 01.48-.25c.251 0 .434.097.547.29v1.334c-.111.193-.296.29-.553.29a.55.55 0 01-.475-.245c-.115-.163-.173-.388-.173-.675z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;